import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, Toaster } from "sonner";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import api from "../lib/api";
import Monogram from "../components/Monogram";

const inputCls =
  "bg-transparent border-0 border-b border-hairline rounded-none px-0 py-3 h-auto text-base text-ink placeholder:text-ink-faint focus-visible:ring-0 focus-visible:border-gold";

const AdminLogin = () => {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password) { toast.error("Enter your email and password."); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/admin/login", { email: email.trim(), password });
      localStorage.setItem("am_admin_token", data.token);
      localStorage.setItem("am_admin_email", data.email);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Unable to sign in.";
      toast.error(msg);
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-[80vh] flex items-center">
      <Toaster richColors position="top-center" />
      <div className="max-w-md w-full mx-auto px-6 lg:px-10 py-16">
        <div className="text-center mb-10">
          <Monogram className="h-20 w-auto mx-auto" />
          <div className="mt-4 text-[10px] tracking-[0.3em] uppercase text-gold">Private Access</div>
          <h1 className="mt-2 font-serif text-4xl text-ink tracking-tight">Admin Sign In</h1>
        </div>

        <form onSubmit={onSubmit} className="border border-hairline bg-ivory p-8 space-y-8" data-testid="admin-login-form">
          <div className="space-y-2">
            <Label className="text-[10px] tracking-[0.3em] uppercase text-gold">Email</Label>
            <Input data-testid="admin-email" type="email" className={inputCls}
              value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
          </div>
          <div className="space-y-2">
            <Label className="text-[10px] tracking-[0.3em] uppercase text-gold">Password</Label>
            <Input data-testid="admin-password" type="password" className={inputCls}
              value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          <button
            type="submit" disabled={busy} data-testid="admin-login-btn"
            className="btn-gold w-full inline-flex items-center justify-center border border-gold text-gold text-[11px] tracking-[0.25em] uppercase px-8 py-4 rounded-full disabled:opacity-60"
          >
            {busy ? "Signing In…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
